import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

const customTheme = (theme) => {
  const {
    palette: {
      common: { white },
    },
    custom: { palette, fontSizes },
  } = theme;
  return createMuiTheme({
    overrides: {
      MuiFormControlLabel: {
        label: {
          color: palette.colorSupportMidnight,
          fontSize: fontSizes.tiny,
          '&$disabled': {
            color: palette.colorSupportMidnight,
          },
        },
        root: {
          marginLeft: 0,
        },
      },
      MuiSwitch: {
        bar: {
          backgroundColor: palette.colorGrayishBlue,
          border: 'solid 2px',
          borderColor: palette.colorGrayishBlue,
          borderRadius: 12,
          height: 12,
          opacity: 1,
          transition: theme.transitions.create(['background-color', 'border-color']),
          width: 24,
        },
        checked: {
          transform: 'translateX(12px)',
          '& + $bar': {
            borderColor: palette.colorSuccess,
            opacity: 1,
          },
        },
        colorSecondary: {
          '&$checked': {
            color: white,
            '& + $bar': {
              backgroundColor: palette.colorSuccess,
            },
          },
        },
        disabled: {
          '&$switchBase': {
            color: white,
            '& + $bar': {
              backgroundColor: palette.colorGrayishBlue,
              borderColor: palette.colorGrayishBlue,
              opacity: 1,
            },
          },
          '&$checked$switchBase': {
            '& + $bar': {
              backgroundColor: palette.colorSuccess,
              borderColor: palette.colorSuccess,
              opacity: 1,
            },
          },
        },
        icon: {
          height: 8,
          width: 8,
        },
        iconChecked: {
          boxShadow: 'none',
        },
        root: {
          display: 'inline-flex',
          flexShrink: 0,
          height: 16,
          marginTop: 3,
          position: 'relative',
          verticalAlign: 'middle',
          width: 30,
        },
        switchBase: {
          height: 8,
          marginTop: 3,
          transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
            easing: theme.transitions.easing.sharp,
          }),
          width: 8,
          zIndex: 1,
          '&$checked': {
            color: white,
            '& + $bar': {
              backgroundColor: palette.colorSuccess,
            },
          },
        },
      },
      MuiTypography: {
        body1: {
          ...theme.typography.body1,
        },
      },
    },
  });
};

class TableInlineSwitch extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      checked: props.checked,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { checked } = this.props;

    if (checked !== nextProps.checked) this.setState({ checked: nextProps.checked });
  }

  handleChange = (event, checked) => {
    const { onChange, forceStateUpdate } = this.props;

    if (onChange) onChange(event, checked);

    if (!onChange || forceStateUpdate) this.setState({ checked });
  };

  render() {
    const { disabled } = this.props;
    const { checked } = this.state;

    return (
      <MuiThemeProvider theme={customTheme}>
        <FormControlLabel
          control={<Switch checked={checked} disableRipple value="" />}
          disabled={disabled}
          label={checked ? 'Enabled' : 'Disabled'}
          onChange={this.handleChange}
        />
      </MuiThemeProvider>
    );
  }
}

TableInlineSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  forceStateUpdate: PropTypes.bool,
  onChange: PropTypes.func,
};

export default TableInlineSwitch;
